import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import {
	ZohoOAuthStatusResponse,
	ZohoConversationSyncResponse,
	ZohoCompanySyncTriggerResponse,
	ZohoCompanyDealCreationTriggerResponse,
	ZohoDealConfigResponse,
} from "../../pages/Company/schema/zoho";

import { zohoApi } from "./zoho.api";

interface ZohoState {
	oauthStatus: ZohoOAuthStatusResponse | null;
	conversationSync: ZohoConversationSyncResponse | null;
	companySyncTrigger: ZohoCompanySyncTriggerResponse | null;
	dealCreationTrigger: ZohoCompanyDealCreationTriggerResponse | null;
	dealConfig: ZohoDealConfigResponse | null;
}

const initialState: ZohoState = {
	oauthStatus: null,
	conversationSync: null,
	companySyncTrigger: null,
	dealCreationTrigger: null,
	dealConfig: null,
};

export const zohoSlice = createSlice({
	name: "zoho",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			zohoApi.endpoints.getZohoOAuthStatus.matchFulfilled,
			(state, { payload }) => {
				state.oauthStatus = payload;
			}
		);
		builder.addMatcher(
			zohoApi.endpoints.getZohoConversationSync.matchFulfilled,
			(state, { payload }) => {
				state.conversationSync = payload;
			}
		);
		builder.addMatcher(
			zohoApi.endpoints.updateZohoConversationSync.matchFulfilled,
			(state, { payload }) => {
				state.conversationSync = payload;
			}
		);
		builder.addMatcher(
			zohoApi.endpoints.getZohoCompanySyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companySyncTrigger = payload;
			}
		);
		builder.addMatcher(
			zohoApi.endpoints.updateZohoCompanySyncTrigger.matchFulfilled,
			(state, { payload }) => {
				state.companySyncTrigger = payload;
			}
		);
		builder.addMatcher(
			zohoApi.endpoints.getZohoCompanyDealCreationTrigger.matchFulfilled,
			(state, { payload }) => {
				state.dealCreationTrigger = payload;
			}
		);
		builder.addMatcher(
			zohoApi.endpoints.updateZohoCompanyDealCreationTrigger.matchFulfilled,
			(state, { payload }) => {
				state.dealCreationTrigger = payload;
			}
		);
		builder.addMatcher(zohoApi.endpoints.getZohoDealConfig.matchFulfilled, (state, { payload }) => {
			state.dealConfig = payload;
		});
		builder.addMatcher(
			zohoApi.endpoints.saveZohoDealConfig.matchFulfilled,
			(state, { payload }) => {
				state.dealConfig = payload;
			}
		);
		builder.addMatcher(zohoApi.endpoints.disconnectZohoOAuth.matchFulfilled, (state) => {
			state.oauthStatus = { connected: false };
		});
	},
});

export const zohoReducer = zohoSlice.reducer;
export const zohoSelector = (state: RootState) => state[zohoSlice.name];
